import axios from 'axios';
import moment from 'moment';

import { CameraConfig } from './cameraConfigs';

export interface CameraProperties {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  photoDate?: Date;
  photoDateDisplay?: string;
  photo?: string;
}

export const fetchCameras = async (configs: CameraConfig[]): Promise<CameraProperties[]> => {
  const allResponses = await Promise.allSettled(
    configs.map((config) =>
      axios.get<string>(`https://apps.lja.com/jeffersondd6/sensera/latestPic/${config.NODE_ID}`, {
        responseType: 'text',
      })
    )
  );

  return configs.map((config, index) => {
    const data: CameraProperties = {
      id: config.NODE_ID,
      name: config.DISPLAY_ID,
      latitude: config.LATITUDE,
      longitude: config.LONGITUDE,
    };

    const queryResponse = allResponses[index];

    if (queryResponse.status !== 'fulfilled') {
      return data;
    }

    try {
      // latestPic query returns a single string with the latest image name.
      // Image name like '[date_ticks].jpg'
      // NOTE: This is not a documented Sensera API and could change.
      const imageName = queryResponse.value?.data;
      data.photoDate = new Date(parseInt(imageName?.replace('.jpg', ''), 10));
      data.photoDateDisplay = moment(data.photoDate).format('M/D/YYYY h:mm a');
      data.photo = `https://apps.lja.com/jeffersondd6/sensera/media/${config.NODE_ID}/${imageName}`;
    } catch {
      // NOOP
    }

    return data;
  });
};

export const formatGeoJSON = (
  cameras: CameraProperties[]
): GeoJSON.FeatureCollection<GeoJSON.Point, CameraProperties> => ({
  type: 'FeatureCollection',
  features: cameras.map((camera, index) => ({
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [camera.longitude, camera.latitude],
    },
    properties: camera,
    id: index + 1,
  })),
});
